var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9467 27.0796H14.5111V6.7699V1.85839H12.52L11.9511 4.24777L8.96444 5.57521L5.83556 4.24777L3.70222 6.7699L4.84 9.42477L3.70222 11.8141L1 12.7434V15.7964L3.70222 16.9911L4.84 19.2478L3.70222 22.1681L6.40444 24.1593L8.96444 23.0973L11.9511 24.1593L12.9467 27.0796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5111 6.7699V1.85839H12.52L11.9511 4.24777L8.96444 5.57521L5.83556 4.24777L3.70222 6.7699L4.84 9.42477L3.70222 11.8141L1 12.7434V15.7964L3.70222 16.9911L4.84 19.2478L3.70222 22.1681L6.40444 24.1593L8.96444 23.0973L11.9511 24.1593L12.9467 27.0796H14.5111V6.7699ZM14.5111 6.7699H24.04V1.56641",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.721 2.78906L24.4676 9.55897H14.6543V13M14.6543 13H31.721M14.6543 13V16.5M14.6543 16.5H31.721M14.6543 16.5V20.1784M14.6543 20.1784H24.4676L31.721 27.0811M14.6543 20.1784V23.0988H24.1832V28.5413",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0847 6.90234C13.0948 6.90234 12.1146 7.09462 11.2001 7.4682C10.2855 7.84177 9.45459 8.38933 8.75464 9.0796C8.05469 9.76988 7.49946 10.5894 7.12065 11.4912C6.74185 12.3931 6.54687 13.3598 6.54688 14.336C6.54688 15.3122 6.74185 16.2788 7.12065 17.1807C7.49946 18.0826 8.05469 18.9021 8.75464 19.5923C9.45459 20.2826 10.2855 20.8302 11.2001 21.2037C12.1146 21.5773 13.0948 21.7696 14.0847 21.7696L14.0847 14.336V6.90234Z",
    fill: "#004357"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 1.25,
    r: 1.25,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6895,
    cy: 2.57812,
    r: 1.25,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 13,
    r: 1.25,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.25,
    cy: 28.8594,
    r: 1.25,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6895,
    cy: 27,
    r: 1.25,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 16.5,
    r: 1.25,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.f416b5dbdab89ccb943196897c80efd3.svg";
export { ForwardRef as ReactComponent };